@if (shouldShowControl()) {
  <div gkControlRow>
    <span gkControlLabel [showLabel]="controlConfig.showLabel">
      <gk-translated-label [configLabel]="controlConfig.label"></gk-translated-label>:</span>
      <span gkControlValue [showLabel]="controlConfig.showLabel">{{getDictValue() | translate}}</span>
    </div>
  }
